// extracted by mini-css-extract-plugin
export var modalFooter = "_r4-0";